import { defineComponent as r, openBlock as e, createElementBlock as a, normalizeClass as o, createTextVNode as i, toDisplayString as n, createElementVNode as s } from "vue";
import { _ as w } from "../../../_plugin-vue_export-helper-dad06003.js";
const l = r({
  name: "VFlag",
  props: {
    text: {
      type: String,
      required: !0
    },
    arrowPosition: {
      validator(t) {
        return ["top", "bottom", "left", "right"].indexOf(t) !== -1;
      }
    }
  }
});
function d(t, p, b, f, g, h) {
  return e(), a("div", {
    class: o([
      "hobi-flag tw-p-2 tw-bg-gray-800 tw-text-white tw-font-sans tw-text-base tw-inline-block tw-rounded tw-border-2 tw-border-solid tw-border-gray-800 tw-relative tw-shadow-xl",
      t.arrowPosition !== void 0 ? "hobi-flag--arrow-" + t.arrowPosition : ""
    ])
  }, [
    i(n(t.text) + " ", 1),
    s("div", {
      class: o([
        "hobi-arrow tw-w-0 tw-h-0 tw-absolute tw-transform",
        t.arrowPosition === "top" ? "hobi-arrow-top tw-right-2/4 tw-translate-x-1/2" : t.arrowPosition === "bottom" ? "hobi-arrow-bottom tw-right-2/4 tw-translate-x-1/2" : t.arrowPosition === "left" ? "hobi-arrow-left tw-top-2/4 tw--translate-y-1/2" : t.arrowPosition === "right" ? "hobi-arrow-right tw-top-2/4 tw--translate-y-1/2" : ""
      ])
    }, null, 2)
  ], 2);
}
const _ = /* @__PURE__ */ w(l, [["render", d], ["__scopeId", "data-v-1b44f9e6"]]);
export {
  _ as default
};
